import { render, staticRenderFns } from "./NewsPost4.vue?vue&type=template&id=32b04b58&"
import script from "./NewsPost4.vue?vue&type=script&lang=ts&"
export * from "./NewsPost4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports